exports = module.exports = require("../../../../../css-loader/dist/runtime/api.js")(false);
// Imports
exports.i(require("-!../../../../../css-loader/dist/cjs.js??ref--7-oneOf-2-1!../../../../../postcss-loader/src/index.js??postcss!./social-networks-theme.css"), "");

// Module
exports.push([module.id, ".c-social-networks {\n  align-self: center;\n  display: flex;\n  justify-content: center;\n}\n\n.c-social-networks > *:not(:last-child) {\n  display: block;\n  padding-right: 0.5rem;\n}\n\n.c-social-networks path {\n  fill: var(--tws-social-networks-icon-color);\n}\n", ""]);

